import React from 'react';
import { ExternalLink } from 'lucide-react';

const LinkPreviewCard = ({ preview }) => {
  if (!preview || !preview.title) return null;

  let hostname = '';
  try { hostname = new URL(preview.url).hostname.replace(/^www\./, ''); } catch {}

  return (
    <a
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="link-preview-card"
      onClick={(e) => e.stopPropagation()}
      className="block mt-1.5 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 transition-opacity hover:opacity-90 max-w-xs shadow-sm"
    >
      {preview.image && (
        <img
          src={preview.image}
          alt={preview.title}
          className="w-full h-28 object-cover"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
      <div className="px-3 py-2">
        {preview.type === 'youtube' && (
          <span className="text-[9px] font-bold uppercase tracking-widest text-red-500">YouTube</span>
        )}
        <p className="text-xs font-semibold leading-snug line-clamp-2 text-slate-800 dark:text-slate-100">
          {preview.title}
        </p>
        {preview.description && (
          <p className="text-[10px] line-clamp-2 mt-0.5 text-slate-500 dark:text-slate-400">
            {preview.description}
          </p>
        )}
        <div className="flex items-center gap-1 mt-1.5 text-slate-400 dark:text-slate-500">
          <ExternalLink className="w-2.5 h-2.5 flex-shrink-0" />
          <span className="text-[10px] truncate">{hostname}</span>
        </div>
      </div>
    </a>
  );
};

export default LinkPreviewCard;
